import { render, staticRenderFns } from "./ConfigContainerPackingDetailDrawer.vue?vue&type=template&id=3cfcf8b2&scoped=true"
import script from "./ConfigContainerPackingDetailDrawer.vue?vue&type=script&lang=ts"
export * from "./ConfigContainerPackingDetailDrawer.vue?vue&type=script&lang=ts"
import style0 from "./ConfigContainerPackingDetailDrawer.vue?vue&type=style&index=0&id=3cfcf8b2&prod&scoped=true&lang=scss"
import style1 from "./ConfigContainerPackingDetailDrawer.vue?vue&type=style&index=1&id=3cfcf8b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfcf8b2",
  null
  
)

export default component.exports